"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const react_native_gesture_handler_1 = require("react-native-gesture-handler");
const react_redux_1 = require("react-redux");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const moment_1 = __importDefault(require("moment"));
const user_1 = require("../../store/selectors/user");
const useDevice_1 = require("../../hooks/useDevice");
const useCharacter_1 = require("../../hooks/useCharacter");
const AppImage_1 = require("../AppImage");
const AppText_1 = require("../AppText");
const utils_1 = require("../../helper/utils");
const theme_1 = require("../../helper/theme");
const application_host_1 = require("../../common/application-host");
const colors_1 = require("../../common/colors");
const constants_1 = require("../../common/constants");
const native_1 = require("@react-navigation/native");
const ConversationListItem = ({ item }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isTabOrDesktopDevice, isWebDevice, isMobileScreen, isPortrait, deviceWidth, } = (0, useDevice_1.useDevice)();
    const navigation = (0, native_1.useNavigation)();
    const { handleSelectCharacter } = (0, useCharacter_1.useCharacter)();
    const appTheme = (0, colors_1.useColorTheme)();
    const conversation = (0, react_redux_1.useSelector)(user_1.selectConversation);
    const [isPressed, setIsPressed] = (0, react_1.useState)(false);
    /**
     *  today : time
     *  yesterday: yesterday
     *  - 2 days ago: wednesday. If within this week.
     *  - 10 days ago : Date
     *
     */
    const conversationTime = (0, react_1.useMemo)(() => {
        // for current date return time
        if ((0, utils_1.isToday)((0, moment_1.default)(item?.lastMessage?.updatedAt))) {
            return (0, moment_1.default)(item?.lastMessage?.updatedAt).format("LT");
        }
        // for current date return time
        if ((0, utils_1.isYesterday)((0, moment_1.default)(item?.lastMessage?.updatedAt))) {
            return "Yesterday";
        }
        // for current date return "day" such as "Friday"
        if ((0, utils_1.isWithinAWeek)((0, moment_1.default)(item?.lastMessage?.updatedAt))) {
            return (0, moment_1.default)(item?.lastMessage?.updatedAt).format("dddd");
        }
        // date default
        return (0, moment_1.default)(item?.lastMessage?.updatedAt).format("MM/DD/YY");
    }, [item]);
    const openChatThread = (0, react_1.useCallback)(async () => {
        if (item?.participant) {
            handleSelectCharacter(item.participant, true, Boolean(item.tutorMode));
        }
        ;
    }, [isTabOrDesktopDevice, item]);
    const onLongPress = (event) => {
        if (event.nativeEvent.state === react_native_gesture_handler_1.State.ACTIVE) {
            setIsPressed(true);
        }
    };
    (0, react_1.useEffect)(() => {
        setIsPressed(false);
    }, []);
    return (
    // <LongPressGestureHandler
    //   onHandlerStateChange={onLongPress}
    //   minDurationMs={1000}
    // >
    // This handler makes scrolling break
    (0, jsx_runtime_1.jsx)(react_native_gesture_handler_1.RectButton, { onPress: openChatThread, style: {
            // we have narrow space on portrait mode Ipad
            paddingHorizontal: isWebDevice && isMobileScreen
                ? 0
                : isTabOrDesktopDevice && isPortrait
                    ? 1
                    : react_native_1.Platform.OS === 'web'
                        ? 12
                        : 10,
            maxWidth: isTabOrDesktopDevice
                ? isPortrait
                    ? constants_1.TAB_PORTRAIT_SIDEBAR_MAX_WIDTH
                    : "100%"
                : theme_1.SCREEN_WIDTH - 20,
            width: "100%",
            height: react_native_1.Platform.OS === 'web'
                ? isMobileScreen
                    ? 85
                    : 80
                : undefined,
            padding: react_native_1.Platform.OS === 'web' ? 8 : 2,
            paddingTop: isWebDevice && isMobileScreen ? 8 : undefined,
            paddingBottom: isWebDevice && isMobileScreen ? 13 : undefined,
            // backgroundColor: isTabOrDesktopDevice
            //   ? Colors.INACTIVECHAT
            //   : Colors.DARK_700,
            ...(isTabOrDesktopDevice &&
                conversation?.id === item?.id && {
                backgroundColor: colors_1.Colors.DARK_600,
            }),
        }, children: (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { children: [" ", (0, jsx_runtime_1.jsxs)(native_base_1.HStack
                // justifyContent="space-between"
                , { 
                    // justifyContent="space-between"
                    space: 4, padding: react_native_1.Platform.OS === 'web' ? undefined : 1, 
                    // mt={2}
                    width: "100%", style: {
                        ...(isPressed && {
                            backgroundColor: colors_1.Colors.LIGHT_GRAY,
                        }),
                    }, children: [(0, jsx_runtime_1.jsx)(native_base_1.VStack, { width: react_native_1.Platform.OS === 'web' ? undefined : isTabOrDesktopDevice && isPortrait ? 55 : 65, maxWidth: react_native_1.Platform.OS === 'web' ? undefined : isTabOrDesktopDevice && isPortrait ? 50 : "20%", mr: isTabOrDesktopDevice && !isWebDevice ? 2 : 0, children: item?.participant && ((0, jsx_runtime_1.jsx)(AppImage_1.AppImage, { size: "xs", url: (0, application_host_1.getThumbnailImageUrl)(item?.participant), style: {
                                    width: isTabOrDesktopDevice && isPortrait && !isWebDevice ? 50 : 64,
                                    height: isTabOrDesktopDevice && isPortrait && !isWebDevice ? 50 : 64,
                                    borderRadius: 6,
                                    borderColor: appTheme.DARK_600,
                                    borderWidth: isWebDevice ? 1 : 0.5,
                                } })) }), (0, jsx_runtime_1.jsxs)(native_base_1.VStack, { ml: isWebDevice ? undefined : 0, width: isWebDevice
                                ? isMobileScreen
                                    ? undefined
                                    : deviceWidth * 0.16
                                : 'auto', maxWidth: !isWebDevice
                                ? isTabOrDesktopDevice && isPortrait
                                    ? 160
                                    : "55%"
                                : undefined, space: isWebDevice ? 2.5 : undefined, justifyContent: isWebDevice && isMobileScreen ? 'center' : undefined, flex: isWebDevice && !isMobileScreen ? 1 : undefined, flexShrink: isWebDevice && isMobileScreen ? 1 : undefined, children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.white, fontWeight: !isWebDevice ? 500 : undefined, fontSize: isWebDevice ? (0, theme_1.normalize)(19) : (0, theme_1.normalize)(18), lineHeight: isWebDevice ? 'normal' : undefined, numberOfLines: 1, children: item?.participant?.characterName }), item?.lastMessage?.isMedia ? ((0, jsx_runtime_1.jsxs)(native_base_1.HStack, { paddingY: 1, space: 2, alignItems: "center", children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faCamera, size: 16, color: colors_1.Colors.DARK_TEXT }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: appTheme.DARK_TEXT, fontSize: (0, theme_1.normalize)(14), lineHeight: isWebDevice ? 14 : undefined, width: isWebDevice
                                                ? undefined
                                                : isTabOrDesktopDevice && isPortrait
                                                    ? 160
                                                    : 220, numberOfLines: 1, children: "Photo" })] })) : ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: isWebDevice && isMobileScreen ? colors_1.Colors.DARK_200 : appTheme.DARK_TEXT, fontSize: isWebDevice ? (0, theme_1.normalize)(15) : (0, theme_1.normalize)(14), lineHeight: isWebDevice ? 'normal' : undefined, width: isWebDevice
                                        ? undefined
                                        : isTabOrDesktopDevice && isPortrait
                                            ? 160
                                            : 220, numberOfLines: 1, children: `${item?.lastMessage?.message || ""}` }))] }), (0, jsx_runtime_1.jsx)(native_base_1.VStack, { children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: isWebDevice ? colors_1.Colors.DARK_300 : appTheme.DARK_TEXT, fontSize: isWebDevice ? (0, theme_1.normalize)(13) : (0, theme_1.normalize)(10), width: !isWebDevice ? 20 : undefined, textAlign: isTabOrDesktopDevice && isPortrait && !isWebDevice ? "left" : "right", children: item?.lastMessage &&
                                    !item?.lastMessage?.isRead &&
                                    conversationTime }) })] })] }) })
    // </LongPressGestureHandler>
    );
};
exports.LastMessage = (({ isMedia, message }) => {
    const appTheme = (0, colors_1.useColorTheme)();
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    return (isMedia ? ((0, jsx_runtime_1.jsxs)(native_base_1.HStack, { space: 2, alignItems: "center", paddingY: 1, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_regular_svg_icons_1.faCamera, color: colors_1.Colors.DARK_TEXT, size: 16 }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: appTheme.DARK_TEXT, fontSize: (0, theme_1.normalize)(14), fontWeight: 400, width: isMobileScreen ? 220 : 160, numberOfLines: 1, children: "Photo" })] })) : ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: appTheme.DARK_TEXT, fontSize: (0, theme_1.normalize)(14), fontWeight: 400, width: isMobileScreen ? 220 : 160, numberOfLines: 1, children: message })));
});
exports.default = (0, react_1.memo)(ConversationListItem);
